import { Component, Input } from '@angular/core';
import { BedPosture } from '../../models/be/bed-state';

@Component({
  selector: 'app-bed-posture-icon',
  template: `
    <img [src]="iconPath" alt="" aria-hidden="true">
  `,
  styles: [':host { display: inline-flex; flex: 0 0 auto; width: 40px; height: 40px; } img { width: 100%; height: 100%; object-fit: contain; }']
})
export class BedPostureIconComponent {
  @Input() state: BedPosture | null = null;

  get iconPath(): string {
    const name = this.state === 'LYING_IN_BED' ? 'bed_sleeping' : this.state === 'SITTING_ON_BED' ? 'bed' : 'bed_empty';
    return `assets/files/customSvg/${name}.svg`;
  }
}

export const bedPosturePresentation = {
  LYING_IN_BED: { label: 'BED_STATES.LYING', css: 'lying' },
  SITTING_ON_BED: { label: 'BED_STATES.SITTING', css: 'sitting' },
  OUT_OF_BED: { label: 'BED_STATES.OUT', css: 'away' }
};

export function posturePresentation(state: BedPosture | null) {
  return state ? bedPosturePresentation[state] : { label: 'BED_STATES.UNKNOWN', css: 'unknown' };
}

export function formatBedDuration(seconds: number): string {
  const total = Number.isFinite(seconds) ? Math.max(0, Math.floor(seconds)) : 0;
  if (total < 60) return `${total}s`;
  if (total < 3600) return `${Math.floor(total / 60)}m ${total % 60}s`;
  return `${Math.floor(total / 3600)}h ${Math.floor(total % 3600 / 60)}m`;
}
